// Subscription benefit codes under which OkCredit sends transaction alerts to the customer.
// Shared by the Transaction Alert toggle gate, the My Plan channel picker and the pending
// upgrade saga (KMP SubscriptionBenefit / AccountProfileModel.hasPremiumPlan).
export const BENEFIT_TXN_SMS = 'UNLIMITED_TXN_SMS_FROM_OKC'
export const BENEFIT_TXN_WHATSAPP = 'UNLIMITED_TXN_WHATSAPP_FROM_OKC'
// Code the web's WhatsApp Premium plan currently carries (see MyPlan/benefitsMeta).
export const BENEFIT_TXN_WHATSAPP_WEB = 'ACCOUNT_ORGANIZATION'

export const isWhatsappAlertBenefit = (code: string) =>
  code === BENEFIT_TXN_WHATSAPP || code === BENEFIT_TXN_WHATSAPP_WEB

// True when this benefit set includes any plan where OkCredit sends the alerts (SMS or WhatsApp).
export const sendsOkcAlerts = (benefits: ReadonlyArray<string>) =>
  benefits.some((code) => code === BENEFIT_TXN_SMS || isWhatsappAlertBenefit(code))
